<script lang="ts">
  import {thumbnail} from '@/store';
  import type {Video} from '@/types/project';
  import {onMount, createEventDispatcher, onDestroy} from 'svelte';
  import editorInstance from '@/lib/editor/editor';
  import {flip} from 'svelte/animate';
  import {dndzone} from 'svelte-dnd-action';
  import editorStore from '@/lib/editor/editor.store';
  import Component from '@/lib/editor/Component/Component';
  import IndividualLayer from './IndividualLayer.svelte';

  export let video: Video;
  export let isOpen: boolean = true;
  let active: Component;
  let zIndexes: any = [];
  const setSelections = (text: string, index: number): any => {
    editorInstance.history.addHistory('Insert Quote/Title');
    if ($thumbnail.type === 'thumbnail') {
      editorInstance.insertTitle(text);
      thumbnail.set({...$thumbnail, title: text});
    } else if ($thumbnail.type === 'quote') {
      editorInstance.insertQuote(text);
      thumbnail.set({...$thumbnail, quote: text});
    }
  };

  $: cssClass = true ? 'fa-eye' : 'fa-eye-slash';

  const flipDurationMs = 200;

  // const unmount = editorStore.subscribe((store) => {
  // //   if (store.activeComponent == item) return;
  // //   show.set(false);
  //     store.components.

  // });

  function updateZIndexes() {
    zIndexes.forEach((item: any, index: number) => {
      if (item && item.element) item.element.style.zIndex = zIndexes.length - index;
    });
  }

  onMount(() => {
    // initializeToolbar();
    zIndexes = $editorStore.components.map((el: Component, index: number) => {
      return {
        element: el.element,
        type: el.type,
        index: index,
        zIndex: parseInt(getComputedStyle(el.element).zIndex, 10) || index + 1
      };
    });

    // Sort by z-index in ascending order
    zIndexes.sort((a: any, b: any) => b.zIndex - a.zIndex);

    updateZIndexes();
  });

  function onMouseOver(element: HTMLElement) {
    editorInstance.ui.highlight(element);
  }

  function onMouseLeave() {
    editorInstance.ui.removeHighlight();
  }

  function handleDndConsider(e: any) {
    zIndexes = e.detail.items;
    updateZIndexes();
  }
  function handleDndFinalize(e: any) {
    zIndexes = e.detail.items;
    updateZIndexes();
  }
</script>

<div
  class={`relative flex h-full w-full flex-shrink-0 flex-col items-center gap-4 overflow-hidden bg-white bg-opacity-10`}
>
  <div class="flex w-full gap-2 px-6">
    <span class="grow font-bold text-black">Layers</span>
    <!-- <button on:click={toggleAside} on:keyup={toggleAside}><i class="fa-solid fa-bars"></i></button> -->
  </div>

  <section
    class="h-ful h-conten flex w-full flex-col items-center gap-2 overflow-y-auto px-4 py-4"
    use:dndzone={{
      items: zIndexes,
      flipDurationMs,
      type: 'columns',
      dragDisabled: false
    }}
    on:consider={handleDndConsider}
    on:finalize={handleDndFinalize}
  >
    {#each zIndexes as item, index (item.index)}
      <div class="flex w-full" animate:flip={{duration: flipDurationMs}}>
        <IndividualLayer {item} />
      </div>
    {/each}
  </section>
</div>

<style lang="postcss">
  .vertical {
    writing-mode: vertical-rl;
  }
  .sideways {
    text-orientation: sideways;
  }
  .max-lines {
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .h-conten {
    height: calc(100vh - 210px);
    height: calc(100svh - 210px);
  }
</style>
